import React, { useMemo } from "react";

/**
 * Very subtle floating gold dust particles. CSS-only animation.
 * Absolutely-positioned; relies on a parent with position:relative.
 */
export const Particles = ({ count = 18 }) => {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 2.2 + 0.6,
        delay: Math.random() * 8,
        dur: 9 + Math.random() * 9,
        opacity: 0.25 + Math.random() * 0.35,
      })),
    [count]
  );

  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 overflow-hidden pointer-events-none"
      data-testid="hero-particles"
    >
      {dots.map((d) => (
        <span
          key={d.id}
          className="particle-dot"
          style={{
            left: `${d.left}%`,
            top: `${d.top}%`,
            width: `${d.size}px`,
            height: `${d.size}px`,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.dur}s`,
            opacity: d.opacity,
          }}
        />
      ))}
    </div>
  );
};
